import OnsiteSearchAppData from '@/onsite/models/onsite-search-app-data.model';

export default window.onsiteSearchAppData as OnsiteSearchAppData;
